import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Truck, Sparkles } from "lucide-react";
import api from "../lib/api";

export default function OrderSuccess() {
  const { order_no } = useParams();
  const [search] = useSearchParams();
  const [order, setOrder] = useState(null);
  const isMock = search.get("mock") === "1";

  useEffect(() => {
    api
      .get(`/orders/${order_no}`)
      .then((r) => setOrder(r.data))
      .catch(() => setOrder(null));
  }, [order_no]);

  return (
    <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 text-center" data-testid="order-success">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
      >
        <span className="inline-flex w-16 h-16 items-center justify-center border border-jow-gold/50 text-jow-gold">
          <CheckCircle2 size={28} />
        </span>
        <span className="block label-overline text-jow-gold mt-6">Order placed</span>
        <h1 className="font-display text-5xl md:text-6xl mt-3 text-jow-navy" data-testid="success-headline">
          Thank you.
        </h1>
        <p className="mt-3 text-jow-navy/60 max-w-lg mx-auto">
          Your order is in the atelier. A rikshaw will set off shortly.
        </p>

        <div className="mt-10 inline-block bg-white border border-jow-gold/40 px-8 py-6">
          <p className="label-overline text-jow-navy/55">Order number</p>
          <p className="font-display text-3xl text-jow-navy mt-1" data-testid="success-order-no">
            {order_no}
          </p>
          <p className="label-overline text-jow-navy/55 mt-5">Total</p>
          <p className="font-display text-2xl text-jow-pink mt-1" data-testid="success-total">
            {order ? `₹${order.total.toLocaleString("en-IN")}` : "Loading…"}
          </p>
        </div>

        {isMock && (
          <p className="mt-6 text-xs text-jow-pink max-w-md mx-auto" data-testid="success-mock-note">
            ⚠ Razorpay test mode — payment is pending until real keys are configured. The order
            is saved and visible in your account.
          </p>
        )}

        <div className="mt-10 flex items-center justify-center gap-2 text-sm text-jow-navy/65">
          <Truck size={14} className="text-jow-gold" />
          Estimated arrival: 3 – 7 days
        </div>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to={`/account/orders/${order_no}`} className="btn-primary-jow" data-testid="success-view-order">
            <Sparkles size={14} /> View order
          </Link>
          <Link to="/shop" className="btn-secondary-jow" data-testid="success-keep-shopping">
            Keep shopping
          </Link>
        </div>
      </motion.div>
    </section>
  );
}
